import React, { Component } from "react";
import "./Signature.css";
import { connect } from "react-redux";

class Signature extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    let logo = `/static/img/brands/newfold.png`;
    let brand = "Newfold Digital";

    let mobileNumber = null;
    let department = null;
    let position = `${this.props.position}`;
    if (this.props.clientFacing === 'no') {
      mobileNumber = `${this.props.mobileNumber}`;
      position = null;
      department = `${this.props.department}`;
    }

    function getOS() {
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
        windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
        iosPlatforms = ["iPhone", "iPad", "iPod"],
        os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = "Mac OS";
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = "iOS";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = "Windows";
      } else if (/Android/.test(userAgent)) {
        os = "Android";
      } else if (!os && /Linux/.test(platform)) {
        os = "Linux";
      }

      return os;
    }

    let logoWidth = null;
    let logoHeight = null;
    let showWarning = null;
    if (getOS() === "Windows") {
      logoWidth = 65 / window.devicePixelRatio;
      logoHeight = 25 / window.devicePixelRatio;
      showWarning = "Logo is not to scale.";
    } else {
      logoWidth = 65;
      logoHeight = 25;
    }



    return (
      <div>
        <div className="card" style={{marginBottom: "24px"}}>
          <div className="email-blue">
            <img src="../../../static/img/ellipses.png"/>
          </div>
          <div className="email-grey">
            <div className="row">
              <div className="col-md-2">
                <p>
                  To:
                </p>
              </div>
              <div className="col-md-10">
                <div className="grey-bar">
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">
                <p>
                  Cc:
                </p>
              </div>
              <div className="col-md-10">
                <div className="grey-bar">
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">
                <p>
                  Subject:
                </p>
              </div>
              <div className="col-md-10">
                <div className="grey-bar">
                </div>
              </div>
            </div>
          </div>
          <div className="email-text">
            <h3>Hello Team Newfold!</h3>
            <p style={{marginBottom: "36px"}}>
              Email signatures are an integral part of our brand standards that
              play an important role in achieving our mission. They define the
              qualities and characteristics of working with Newfold Digital. They help
              us set the right expectations for prospects who become customers
              and job seekers who become employees. Lastly they help us ensure
              consistent experiences across applications, devices, and settings.
            </p>
          
            <table width={420} cellSpacing={0} cellPadding={0} border={0}>
              <tbody>
                <tr>
                  <td>
                    <table cellSpacing={0} cellPadding={0} border={0}>
                      <tbody>
                        
                        <tr>
                          <td
                            style={{ fontSize: "1em" }}
                            valign="top"
                          >
                            <table
                              cellSpacing={0}
                              cellPadding={0}
                              border={0}
                              style={{
                                lineHeight: "15px",
                                fontFamily: "Arial, Helvetica, sans-serif",
                                color: "#000000"
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <div
                                      style={{
                                        fontFamily:
                                          "Arial, Helvetica, sans-serif",
                                        color: "#ec5328",
                                        fontSize: "12px",
                                        fontWeight: "700",
                                        lineHeight: "11.5pt",
 
                                      }}
                                    >
                                      {this.props.name} <br></br>
                                      {position}
                                      {department}
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        lineHeight: "10px"
                                      }}
                                    >
                                      &nbsp;
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <div
                                      style={{
                                        fontFamily:
                                          "Arial, Helvetica, sans-serif",
                                        color: "#000000",
                                        fontSize: "12px",
                                        lineHeight: "15px",
                                      }}
                                    >
                                      <span style={{
                                        fontWeight: 700,
                                        color: "#ec5328"
                                        }}
                                        >O:&nbsp;
                                      </span> 
                                      {this.props.phone}
                                      {mobileNumber? (<span><span style={{fontWeight: 700, color: "#ec5328"}}>&nbsp;&nbsp;&nbsp;C:&nbsp;</span>{mobileNumber}</span>): null}<br></br>
                                      {this.props.email}
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        lineHeight: "10px"
                                      }}
                                    >
                                      &nbsp;
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <div
                                      style={{
                                        fontFamily:
                                          "Arial, Helvetica, sans-serif",
                                        color: "#000000",
                                        fontSize: "12px",
                                        lineHeight: "15px",
                                      }}
                                    >
                                      <span dangerouslySetInnerHTML={{
                                        __html: this.props.location
                                      }}></span>
                                    </div>
                                  </td>
                                </tr>

                              </tbody>
                            </table>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                    <table cellSpacing={0} cellPadding={0} border={0}>
                      <tbody>
                        <tr>
                          <td>
                            <div
                              style={{
                                fontSize: "12px",
                                lineHeight: "10px"
                              }}
                            >
                              &nbsp;
                            </div>
                          </td>
                        </tr>
                        <tr>
                          
                          <td
                            style={{ fontSize: "1em" }}
                            valign="top"
                            >
                            <span>
                              <img
                                src={logo}
                                alt={brand}
                                style={{
                                  "maxwidth": `${logoWidth}px`,
                                  "maxheight": `${logoHeight}px`,
                                  "height": `${logoHeight}px`,
                                  "width": `${logoWidth}px`
                                }}
                                maxwidth={logoWidth}
                                maxheight={logoHeight}
                                height={logoHeight}
                                width={logoWidth}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    location: state.form.location,
    brand: state.form.brand,
    name: state.form.name,
    position: state.form.position,
    department: state.form.department,
    phone: state.form.phone,
    email: state.form.email,
    clientFacing: state.signatureType.clientFacing,
    subBrand: state.form.subBrand,
    mobileNumber: state.form.mobileNumber
  };
};

export default connect(mapStateToProps)(Signature);



// WEBPACK FOOTER //
// ./src/components/Signature/Signature.js